export function isStaffUser(fulluser) {
  return localStorage.getItem('role') === 'staff'
    || fulluser?.is_staff === true
    || fulluser?.role === 'staff';
}

export function currentStaffId(fulluser) {
  return localStorage.getItem('staff_id') || fulluser?.staff_id || '';
}
